// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"19":"127a7839","166":"b4aafe41","391":"09a4df05","787":"3e189465","854":"458906c0","960":"27abff8d"}[chunkId] + ".css";
};